import React from 'react';
import { useLocation } from 'react-router-dom';
function GeocatalogAgreement() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page') || 1;

  return (
    <div className="pdf-page">
    <iframe
      src={`/pdf/Geocatalog_agreement.pdf#page=${page}`}
      title="PDF Document"
        width="100%"
        height="600px"
    />
  </div>
  );
}

export default GeocatalogAgreement;
